// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import RadioSelector from '../controls/RadioSelector'
import ImagePreview from '../ImagePreview'
import getDefaultCrop from '../getDefaultCrop'
import ResponsibleRect from './ResponsibleRect'
import type { PreviewData } from './NamedPreview'

type Props = {|
  previews: Array<PreviewData>,
  selectedIndex: number,
  onChange: (index: number) => void
|}

export default class AdvertisementPreviewSwitcher extends Component<Props> {
  render() {
    const { previews, selectedIndex, onChange } = this.props

    const renderers = _.map(previews, (preview, index: number) => ({
      value: index,
      renderer: this.renderer(preview)
    }))
    return (
      <RadioSelector
        radioOptions={renderers}
        value={selectedIndex}
        onChange={(value) => onChange(value)}
      />
    )
  }

  renderer(preview: PreviewData) {
    const previewMedia = preview.vkBigImage || preview.image || preview.video
    return previewMedia ? (
      <ImagePreview
        imageSrc={previewMedia.src}
        size={{
          width: previewMedia.width,
          height: previewMedia.height
        }}
        width={50}
        crop={getDefaultCrop(previewMedia.width, previewMedia.height, 1.0)}
      />
    ) : (
      <ResponsibleRect width={50} ratio={1} />
    )
  }
}
